import React, { FC, useState } from 'react';

import { IEvButtonProps } from '@evinced-private/ui-common';

import { removeMetaFieldsFromUrlSetConfig } from '../../helpers/UrlSetHelper';
import { IUrlSet } from '../../interfaces/UrlSet';
import { getUrlSet } from '../../services/UrlSetService';
import { JsonPopup } from '../json-popup/JsonPopup';

interface IUrlSetConfigProps {
	urlSetId: string;
	triggerButtonProps: IEvButtonProps;
}

export const UrlSetConfigPopup: FC<IUrlSetConfigProps> = ({ urlSetId, triggerButtonProps }) => {
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [urlSetConfig, setUrlSetConfig] = useState<IUrlSet>(null);

	const loadUrlSet = async (): Promise<void> => {
		setIsLoading(true);
		const urlSetConfig = await getUrlSet(urlSetId);
		const cleanUrlSetConfig = removeMetaFieldsFromUrlSetConfig(urlSetConfig);
		setUrlSetConfig(cleanUrlSetConfig);
		setIsLoading(false);
	};

	return (
		<JsonPopup
			title="Url Set Configuration"
			initialValue={urlSetConfig}
			isReadonly={true}
			approveButtonText="Close"
			onApprove={(dataToSave, close) => {
				close();
			}}
			onOpen={loadUrlSet}
			triggerButtonProps={triggerButtonProps}
			isLoading={isLoading}
		/>
	);
};
